/**
 * Service Ticket form — dual submit.
 *
 * The form is a native Shopify `{% form 'contact' %}` (so it keeps sending the
 * store's contact-email notification and shows Shopify's success page). On top
 * of that, we ALSO post the same data to HubSpot's Forms API v3 so the ticket
 * lands in the CRM.
 *
 * Dual-submit mechanics: we do NOT preventDefault. We fire the HubSpot request
 * with `keepalive: true` (which survives the native form's page navigation),
 * then let Shopify's native POST continue. Shopify's email is the primary path;
 * HubSpot is best-effort in parallel.
 *
 * Field names differ (Shopify uses contact[...]; HubSpot uses its own property
 * names), so we map explicitly. ticket_type sends the option LABEL to match
 * HubSpot's dropdown enumeration (its internal values are the full labels).
 */
(function () {
  'use strict';

  var PORTAL_ID = '50831863';
  var FORM_ID = '2858491b-adc9-4fe8-a261-962e9485ad6b';

  // Shopify contact-field name -> HubSpot property name
  var FIELD_MAP = {
    'contact[first_name]': 'firstname',
    'contact[last_name]': 'lastname',
    'contact[email]': 'email',
    'contact[phone]': 'phone',
    'contact[subject]': 'subject',
    'contact[body]': 'message',
  };

  function getCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : '';
  }

  function buildPayload(form) {
    var fields = [];
    Object.keys(FIELD_MAP).forEach(function (shopName) {
      var el = form.querySelector('[name="' + shopName + '"]');
      if (el && el.value) {
        fields.push({ objectTypeId: '0-1', name: FIELD_MAP[shopName], value: el.value });
      }
    });

    // ticket_type: send the visible option label (matches HubSpot's enum values,
    // which are the full labels — the form's option VALUEs are lowercase_underscore).
    var tt = form.querySelector('[name="contact[ticket_type]"]');
    if (tt && tt.value) {
      var label = tt.options && tt.options[tt.selectedIndex] ? tt.options[tt.selectedIndex].text : tt.value;
      fields.push({ objectTypeId: '0-1', name: 'ticket_type', value: label });
    }

    var context = { pageUri: window.location.href, pageName: document.title };
    var hutk = getCookie('hubspotutk');
    if (hutk) context.hutk = hutk;

    return { fields: fields, context: context };
  }

  function sendToHubSpot(form) {
    var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL_ID + '/' + FORM_ID;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildPayload(form)),
      keepalive: true,
    });
  }

  function init() {
    var form = document.querySelector('.service-ticket-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      // The submit event only fires after native constraint validation passes,
      // so required fields are already filled. Fire HubSpot in parallel and let
      // Shopify's native submit proceed (no preventDefault).
      try {
        sendToHubSpot(form).catch(function (err) {
          if (window.console) console.error('[service-ticket] HubSpot submission error:', err);
        });
      } catch (err) {
        if (window.console) console.error('[service-ticket] HubSpot submission error:', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
